import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UserProfile {
    fullName: string;
    firstName: string;
    lastName: string;
    email: string;
    organizations: { organizationName: string; supplierNpi: string; role: string }[];
}

export interface AuthSliceState {
    accessToken?: string;
    selectedNpi?: string;
    permissions: string[];
    supplierFeatures?: string[];
    profile?: UserProfile;
}

const initialState: AuthSliceState = {
    accessToken: undefined,
    selectedNpi: undefined,
    permissions: [],
    supplierFeatures: undefined,
    profile: undefined,
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setNpi(
            state,
            action: PayloadAction<{
                accessToken: string;
                selectedNpi: string;
                permissions: string[];
            }>,
        ) {
            const { accessToken, selectedNpi, permissions } = action.payload;
            return {
                ...state,
                accessToken,
                selectedNpi,
                permissions,
            };
        },
        setSupplierFeatures(state, action: PayloadAction<{ supplierFeatures: string[] }>) {
            const { supplierFeatures } = action.payload;
            return { ...state, supplierFeatures };
        },
        setProfile(state, action: PayloadAction<{ profile: UserProfile }>) {
            const { profile } = action.payload;
            return {
                ...state,
                profile,
            };
        },
    },
});

export const { setNpi, setSupplierFeatures, setProfile } = authSlice.actions;
